import * as PIXI from 'pixi.js'
import { GlowFilter } from 'pixi-filters'
import gsap from 'gsap'
import MyApplication from '../../../pixi/MyApplication'
import AssetsManager from '../../../pixi/AssetsManager'
import MathUtil from '../../../util/MathUtil'

/**
 * EffectViewクラス
 */
class EffectView extends PIXI.Container {
  // ---------------------------------------------------------------------------------------------------------
  // --	VARS
  // ---------------------------------------------------------------------------------------------------------

  //アップデートメソッド
  private _update: () => void

  // ---------------------------------------------------------------------------------------------------------
  // --	EffectView
  // ---------------------------------------------------------------------------------------------------------

  /**
   * コンストラクタ
   */
  constructor() {
    super()

    //演出エフェクト
    const effect: PIXI.Container = new PIXI.Container()
    effect.alpha = 0.0
    this.addChild(effect)

    const card: PIXI.Sprite = AssetsManager.instance.createSpriteByName('card_effect.png')
    card.anchor.set(0.5)
    card.scale.set(3.0)
    effect.addChild(card)

    //グローフィルター
    const glowFilter: GlowFilter = new GlowFilter({
      distance: 30,
      outerStrength: 3,
      innerStrength: 0,
      color: 0xffff00,
      quality: 0.5,
    })
    card.filters = [glowFilter]

    //Tween
    gsap.to(effect, {
      alpha: 1.0,
      duration: 0.3,
      delay: 0.1,
      ease: 'none',
      onComplete: () => {
        gsap.to(effect, {
          alpha: 0.0,
          duration: 0.3,
          ease: 'none',
          onStart: () => {
            this.splash()
          },
        })
        gsap.to(effect.scale, {
          x: 1.5,
          y: 1.5,
          duration: 0.3,
          ease: 'power1.in',
          onComplete: () => {
            card.filters = []
            this.removeChild(effect)
          },
        })
      },
    })

    //アップデート
    this._update = this.update.bind(this)
    // MyApplication.app.ticker.add(this._update)
  }

  /**
   * スプラッシュ
   */
  splash(): void {
    const lightNum: number = 30
    const rotUnit: number = 360 / lightNum
    const startRot: number = Math.random() * rotUnit
    for (let i: number = 0; i < lightNum; i++) {
      //角度
      const radian: number = MathUtil.degreeToRadian(startRot + rotUnit * i)

      //ライト生成
      const light: PIXI.Sprite = AssetsManager.instance.createSpriteByName('light.png')
      light.anchor.set(1, 0.5)
      light.scale.set(3)
      light.rotation = radian
      light.x = Math.cos(radian) * 30
      light.y = Math.sin(radian) * 30
      this.addChildAt(light, 0)

      //飛び散る
      gsap.to(light, {
        x: Math.cos(radian) * 600,
        y: Math.sin(radian) * 600,
        alpha: 0,
        duration: 0.6,
        ease: 'power1.in',
        onComplete: () => {
          gsap.killTweensOf(light.scale)
          this.removeChild(light)
        },
      })

      //拡大縮小
      gsap.to(light.scale, {
        x: 18,
        duration: 0.3,
        ease: 'power1.in',
        onComplete: () => {
          gsap.to(light.scale, {
            x: 3,
            duration: 0.6,
            ease: 'power1.out',
          })
        },
      })
    }
  }

  /**
   * ライト生成
   */
  createLight(): void {}

  /**
   * アップデート
   */
  private update() {}

  // ---------------------------------------------------------------------------------------------------------
}

export default EffectView
